module.exports = __webpack_public_path__ + "static/hoppys-2-d219c7e289e27efb62dca219bcf5bb8b.jpg";